import axios from "axios";

const BALLPARK_BACKEND_BASE_URL = import.meta.env.VITE_BALLPARK_API_URL;
const BASE_HATTRICK_URL = import.meta.env.VITE_HATTRICK_URL;

export const getOrderHistoryBySchool = (
  user,
  data,
  startDate,
  endDate,
  view
) => {
  let headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + user.stsTokenManager.accessToken,
  };
  return axios.post(
    BALLPARK_BACKEND_BASE_URL + "getOrderHistory",
    { data, startDate, endDate, view },
    { headers }
  );
};

const encodeBase64 = (data) => {
  return btoa(JSON.stringify(data));
};

export const getFinancialTotals = (
  user,
  data,
  startDate,
  endDate,
  view
) => {
  let headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + user.stsTokenManager.accessToken,
  };

  const encodedData = encodeBase64(data);

  const params = {
    view: view || '',
    startDate,
    endDate,
    data: encodedData,
  };

  return axios.get(BASE_HATTRICK_URL + "dashboard/financial/totals", {
    headers,
    params,
  });
};

export const getFinancialOrderTransaction = (
  user,
  data,
  startDate,
  endDate,
  view
) => {
  let headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + user.stsTokenManager.accessToken,
  };

  const encodedData = encodeBase64(data);

  const params = {
    view: view || '',
    startDate,
    endDate,
    data: encodedData,
  };

  return axios.get(BASE_HATTRICK_URL + "dashboard/financial/records", {
    headers,
    params,
  });
};

export const getFinancialFlattened = (
  user,
  data,
  startDate,
  endDate,
  view
) => {
  let headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + user.stsTokenManager.accessToken,
  };

  const encodedData = encodeBase64(data);

  const params = {
    view: view || '',
    startDate,
    endDate,
    data: encodedData,
  };

  return axios.get(BASE_HATTRICK_URL + "dashboard/financial/download", {
    headers,
    params,
    responseType: 'blob'
  }
  );
};

export const getAnalyticsOptions = (data, user) => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + user.stsTokenManager.accessToken,
  };

  const encodedData = encodeBase64(data);

  const params = {
    analyticsOptions: encodedData,
  };

  return axios.get(BASE_HATTRICK_URL + "dashboard/analytics/options", {
    headers,
    params,
  });
};

export const getAnalyticsTotals = (
  user,
  data,
  startDate,
  endDate,
  view
) => {
  let headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + user.stsTokenManager.accessToken,
  };

  const encodedData = encodeBase64(data);

  const params = {
    view: view || '',
    startDate,
    endDate,
    data: encodedData,
  };

  return axios.get(
    BASE_HATTRICK_URL + "dashboard/analytics/totals",
    {
      headers,
      params
    }
  );
};

export const getAnalyticsOrderTransaction = (
  user,
  data,
  startDate,
  endDate,
  view
) => {
  let headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + user.stsTokenManager.accessToken,
  };

  const encodedData = encodeBase64(data);

  const params = {
    view: view || '',
    startDate,
    endDate,
    data: encodedData,
  };

  return axios.get(BASE_HATTRICK_URL + "dashboard/analytics/records", {
    headers,
    params,
  });
};

export const getAnalyticsFlattened = (
  user,
  data,
  startDate,
  endDate,
  view
) => {
  let headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + user.stsTokenManager.accessToken,
  };

  const encodedData = encodeBase64(data);

  const params = {
    view: view || '',
    startDate,
    endDate,
    data: encodedData,
  };

  return axios.get(BASE_HATTRICK_URL + "dashboard/analytics/download", {
    headers,
    params,
    responseType: 'blob',
  });
};